import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { Analytics } from '@vercel/analytics/react'
// import { AuthProvider } from './context/AuthContext'
// import ProtectedRoute from './components/auth/ProtectedRoute'
import Navigation from './components/Navigation'
import NotificationBanner from './components/NotificationBanner'
import Breadcrumbs from './components/Breadcrumbs'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'
import PopUpReddit from './components/PopUpReddit'
import PopUpNewsletter from './components/PopUpNewsletter'
import SchemaMarkup from './components/SchemaMarkup'
import CanonicalUrl from './components/CanonicalUrl'
import Home from './pages/Home'
import DirectoryIaePage from './pages/DirectoryIaePage'
import DirectoryCnae2025Page from './pages/DirectoryCnae2025Page'
import DirectoryCnae2009Page from './pages/DirectoryCnae2009Page'
import IaeDetailsPage from './pages/IaeDetailsPage'
import Cnae2025DetailsPage from './pages/Cnae2025DetailsPage'
import Cnae2009DetailsPage from './pages/Cnae2009DetailsPage'
import CookiesConfig from './pages/CookiesConfig'
import TermsConditions from './pages/TermsConditions'
import PrivacyPolicy from './pages/PrivacyPolicy'
import CorrespondenceCnaePage from './pages/CorrespondenceCnaePage'
import ComparisonPage from './pages/ComparisonPage'
import ComparisonResultsPage from './pages/ComparisonResultsPage'
import NewsletterPage from './pages/NewsletterPage'
import SponsorsPage from './pages/SponsorsPage'
import NotFound from './pages/NotFound'
// import AuthPage from './pages/AuthPage'

// Import styles
import './styles/global.css'
// import './styles/auth.css'

/**
 * PageWrapper component to include CanonicalUrl in each page
 * @param {Object} props - Component props
 * @param {string} props.canonicalUrl - Optional explicit canonical URL to use
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} - Wrapped page with canonical URL
 */
const PageWrapper = ({ canonicalUrl, children }) => {
  return (
    <>
      <CanonicalUrl url={canonicalUrl} />
      {children}
    </>
  )
}

function App() {
  return (
    // <AuthProvider>
    <Router>
      <div className='app'>
        {/* Website Schema */}
        <SchemaMarkup
          type='WebSite'
          data={{
            name: 'Conversor de Códigos IAE y CNAE para Autónomos y Empresas',
            url: 'https://conversoriaecnae.es',
            description:
              'Herramienta para convertir epígrafes IAE a códigos CNAE 2025 y viceversa. Encuentra la equivalencia entre códigos de actividades económicas actualizados.',
          }}
        />

        {/* Service Schema */}
        <SchemaMarkup
          type='Service'
          data={{
            name: 'Conversor de Códigos IAE y CNAE',
            description:
              'Servicio de conversión entre epígrafes IAE y códigos CNAE para autónomos y empresas en España',
            provider: 'Conversor IAE CNAE',
            serviceType: 'Conversión de códigos fiscales',
          }}
        />

        {/* LocalBusiness Schema */}
        <SchemaMarkup
          type='LocalBusiness'
          data={{
            name: 'Conversor IAE CNAE',
            description:
              'Herramienta especializada para la conversión de códigos fiscales para empresas y autónomos en España',
            url: 'https://conversoriaecnae.es',
            email: 'info@conversoriaecnae.es',
          }}
        />

        <NotificationBanner />
        <Navigation />
        <Breadcrumbs />
        <main className='main-content'>
          <Routes>
            <Route
              path='/'
              element={
                <PageWrapper>
                  <Home />
                </PageWrapper>
              }
            />
            <Route
              path='/epigrafes-iae/'
              element={
                <PageWrapper>
                  <DirectoryIaePage />
                </PageWrapper>
              }
            />
            <Route
              path='/codigos-cnae-2025/'
              element={
                <PageWrapper>
                  <DirectoryCnae2025Page />
                </PageWrapper>
              }
            />
            <Route
              path='/codigos-cnae-2009/'
              element={
                <PageWrapper>
                  <DirectoryCnae2009Page />
                </PageWrapper>
              }
            />
            <Route
              path='/correspondencia-entre-codigos-cnae-2025-cnae-2009/'
              element={
                <PageWrapper>
                  <CorrespondenceCnaePage />
                </PageWrapper>
              }
            />
            <Route
              path='/comparador-codigos/'
              element={
                <PageWrapper>
                  <ComparisonPage />
                </PageWrapper>
              }
            />
            <Route
              path='/resultados-comparacion/'
              element={
                <PageWrapper>
                  <ComparisonResultsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/iae/:cod_iae/:slug_iae/'
              element={
                <PageWrapper>
                  <IaeDetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/iae/:cod_iae/'
              element={
                <PageWrapper>
                  <IaeDetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/iae/'
              element={
                <PageWrapper>
                  <DirectoryIaePage />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2025/:cod_cnae/:slug_cnae/'
              element={
                <PageWrapper>
                  <Cnae2025DetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2025/:cod_cnae/'
              element={
                <PageWrapper>
                  <Cnae2025DetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2025/'
              element={
                <PageWrapper>
                  <DirectoryCnae2025Page />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2009/:cod_cnae_2009/:slug_cnae_2009/'
              element={
                <PageWrapper>
                  <Cnae2009DetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2009/:cod_cnae_2009/'
              element={
                <PageWrapper>
                  <Cnae2009DetailsPage />
                </PageWrapper>
              }
            />
            <Route
              path='/cnae-2009/'
              element={
                <PageWrapper>
                  <DirectoryCnae2009Page />
                </PageWrapper>
              }
            />
            <Route
              path='/cookies-configuracion/'
              element={
                <PageWrapper>
                  <CookiesConfig />
                </PageWrapper>
              }
            />
            <Route
              path='/terminos-condiciones/'
              element={
                <PageWrapper>
                  <TermsConditions />
                </PageWrapper>
              }
            />
            <Route
              path='/politica-privacidad/'
              element={
                <PageWrapper>
                  <PrivacyPolicy />
                </PageWrapper>
              }
            />
            <Route
              path='/newsletter/'
              element={
                <PageWrapper>
                  <NewsletterPage />
                </PageWrapper>
              }
            />
            <Route
              path='/patrocinadores/'
              element={
                <PageWrapper>
                  <SponsorsPage />
                </PageWrapper>
              }
            />
            {/* <Route path='/auth' element={<PageWrapper><AuthPage /></PageWrapper>} /> */}

            {/* Protected routes example - uncomment and modify as needed */}
            {/* <Route 
                path='/protected-route' 
                element={
                  <ProtectedRoute>
                    <ProtectedComponent />
                  </ProtectedRoute>
                } 
              /> */}

            {/* Ruta para manejar páginas no encontradas (404) */}
            <Route
              path='*'
              element={
                <PageWrapper>
                  <NotFound />
                </PageWrapper>
              }
            />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <PopUpReddit />
        <PopUpNewsletter />
        <SpeedInsights />
        <Analytics />
      </div>
    </Router>
    // </AuthProvider>
  )
}

export default App
